export const accounts_transactions_data = [
  {
    key: "1",
    id: "FT624893",
    description: "April Month Fees",
    date: "25 Apr 2024",
    amount: "RM15,000",
    type: "Income",
    method: "Cash",
    status: "Completed",
  },
  {
    key: "2",
    id: "FT624892",
    description: "Monthly Electricity",
    date: "27 Apr 2024",
    amount: "RM1000",
    type: "Expense",
    method: "Credit",
    status: "Completed",
  },
  {
    key: "3",
    id: "FT624891",
    description: "Alumni Scholarship",
    date: "03 May 2024",
    amount: "RM1000",
    type: "Income",
    method: "Cash",
    status: "Pending",
  },
  {
    key: "4",
    id: "FT624890",
    description: "AC Repair",
    date: "15 May 2024",
    amount: "RM400",
    type: "Expense",
    method: "Cash",
    status: "Completed",
  },
  {
    key: "5",
    id: "FT624889",
    description: "Uniform Sales",
    date: "20 May 2024",
    amount: "RM10,500",
    type: "Income",
    method: "Credit",
    status: "Completed",
  },
  {
    key: "6",
    id: "FT624888",
    description: "Water Bill",
    date: "06 Jun 2024",
    amount: "RM700",
    type: "Expense",
    method: "Cash",
    status: "Pending",
  },
  {
    key: "7",
    id: "FT624887",
    description: "Library Donation",
    date: "18 Jun 2024",
    amount: "RM2,000",
    type: "Income",
    method: "Cash",
    status: "Completed",
  },
  {
    key: "8",
    id: "FT624886",
    description: "Vehicle Repair",
    date: "26 Jun 2024",
    amount: "RM800",
    type: "Expense",
    method: "Cash",
    status: "Completed",
  },
  {
    key: "9",
    id: "FT624885",
    description: "Cafeteria Income",
    date: "08 Jul 2024",
    amount: "RM15,000",
    type: "Income",
    method: "Credit",
    status: "Completed",
  },
  {
    key: "10",
    id: "FT624884",
    description: "Lab Equipments",
    date: "10 Jul 2024",
    amount: "RM300",
    type: "Expense",
    method: "Cash",
    status: "Completed",
  },
];
